import React from 'react';
import { VictoryChart, VictoryBar, VictoryTooltip, VictoryAxis, VictoryLabel } from 'victory';

export const IaksByDayDistribution = ({ data, barTooltip, tickValues, tickFormat, showStroke = false }) => {
  return (
    data && data.some(item => item.y > 0) &&
    <div className="chart-container">
      <div className="chart-title">Number of IAK-s per Day</div>
      <VictoryChart  domainPadding={{ x: 10 }}>
        <VictoryBar labelComponent={<VictoryTooltip/>} labels={barTooltip}
                    data={data} padding={ { top: 0, bottom: 0, right: 10, left: 10 } }
                    style={{ data: { fill: '#fa748d' } }} />
        <VictoryAxis tickValues={tickValues} tickFormat={tickFormat} fixLabelOverlap={true}
                     style={ showStroke ? {grid:{ stroke: '#c0c5c6', strokeDasharray: 5}} : null }
                     tickLabelComponent={<VictoryLabel renderInPortal/>}/>
      </VictoryChart>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/charts/iaksByDayDistribution.js